import React, { useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from './SupportCenterView.module.scss';

import { Container } from 'ui/components/4-habitats';
import { Heading } from 'ui/components/1-atoms';
import { PageSpinner } from 'ui/components/1-atoms';

export interface SupportCenterViewProps {
	className?: string;
	heading?: string;
	isLoading?: boolean;
}

export const SupportCenterView = ({
	className,
	heading = 'Support Center',
	isLoading = false,
}: SupportCenterViewProps) => {
	return (
		<Container
			width="Standard"
			textAlign="Left"
			className={classNames(styles.SupportCenterView, className)}
		>
			<div className={classNames(styles.SupportCenterView_header)}>
				<Heading
					headingLevel="h1"
					style="xl"
					className={classNames(styles.SupportCenterView_heading)}
				>
					{heading}
				</Heading>
				{/* TODO: Add filter buttons here */}
			</div>
			{/* TODO: Add Ticket table here */}

			{isLoading && <PageSpinner />}
		</Container>
	);
};
